<template>
      <div >
        <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
          <div id="1" style="height: 800px;width: 50%;float:left;border-right: 1px solid #999"></div>
          <div id="2" style="height: 800px;width: 50%;float:left;border-right: 1px solid #999"></div>
        </div>

        <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
          <div id="3" style="height: 600px;width: 50%;float:left;border-right: 1px solid #999"></div>
          <div id="4" style="height: 600px;width: 50%;float:left;border-right: 1px solid #999"></div>
        </div>

        <div style="overflow: hidden;border:1px solid #999;margin-bottom: 20px; ">
          <div id="5" style="height: 400px;width: 50%;float:left;border-right: 1px solid #999"></div>
          <div id="6" style="height: 400px;width: 50%;float:left;border-right: 1px solid #999"></div>
        </div>
      </div>

</template>

<script>
  import URL from '@/views/analyse/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  const Echarts = require('echarts');
    export default {
        name: 'analy',
        mounted(){
            this.init();
        },
        methods: {
            init(){
                this.$axios.get(URL.deviceVn.analy+"?businessType="+DateUtil.getParamKey(this.$route.params)).then(res => {
                    if(res.code == 0 && res.result){
                        this.setOption("1", window.$t("analyse.device.systemAnaly") ,res.result.platform);
                        this.setOption("2", window.$t("analyse.device.phoneAnaly"),res.result.manufacturer);
                        this.setOption("3", window.$t("analyse.device.phoneSystemAnaly"),res.result.phoneModel);
                        this.setOption("4", window.$t("analyse.device.appVersionAnaly"),res.result.appVersion);
                        this.setOption("5", window.$t("analyse.device.phoneWifiAnaly"),res.result.networkType);
                        this.setOption("6", window.$t("analyse.device.appChannelAnaly"),res.result.channel);
                    }
                });
            },
            /*渲染图一，饼状图*/
            setOption(id,title,arr){
                const legendArr = [];
                for (let i in arr) {
                    if (arr[i].name == '') arr[i].name = window.$t("analyse.device.other");
                    legendArr.push(arr[i].name);
                }
                console.log(arr);
                Echarts.init(document.getElementById(id)).setOption({
                    title : {
                        text: title,
                        x:'left'
                    },
                    tooltip : {
                        trigger: 'item',
                        formatter: "<br/>{b} : {c} ({d}%)"
                    },
                    legend: {
                        top:"30",
                        orient: 'horizontal',
                        left: 'left',
                        data: legendArr
                    },
                    series : [
                        {
                            type: 'pie',
                            radius : '55%',
                            center: ['50%', '60%'],
                            //显示数据和数据所占比例
                            label: {
                                normal: {
                                    show: true,
                                    formatter: '{b}: {c}({d}%)',
                                    color:"#000000"
                                }
                            },
                            data:arr
                        }
                    ]
                });
            },

        }
    }
</script>
